/**
 * Âm thanh ngắn (Web Audio) khi đúng/sai — không cần file mp3.
 */
let sharedCtx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  try {
    if (typeof window === 'undefined') return null;
    if (!sharedCtx) {
      sharedCtx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
    }
    return sharedCtx;
  } catch {
    return null;
  }
}

function beep(
  ctx: AudioContext,
  freq: number,
  start: number,
  duration: number,
  volume: number,
  type: OscillatorType = 'sine'
) {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(ctx.destination);
  g.gain.setValueAtTime(0, start);
  g.gain.linearRampToValueAtTime(volume, start + 0.02);
  g.gain.exponentialRampToValueAtTime(0.001, start + duration);
  o.start(start);
  o.stop(start + duration + 0.02);
}

/** Hợp âm vui (C–E–G) */
export function playMovementSuccessSound(volume = 0.32): void {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === 'suspended') void ctx.resume();
  const t = ctx.currentTime;
  const v = Math.min(0.45, Math.max(0.08, volume));
  const freqs = [523.25, 659.25, 783.99];
  freqs.forEach((f, i) => beep(ctx, f, t + i * 0.06, 0.28, v * (1 - i * 0.08)));
}

/** Tông trầm, gọn — gợi thử lại */
export function playMovementWrongSound(volume = 0.22): void {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === 'suspended') void ctx.resume();
  const t = ctx.currentTime;
  const v = Math.min(0.35, Math.max(0.06, volume));
  beep(ctx, 180, t, 0.12, v * 0.7, 'triangle');
  beep(ctx, 155, t + 0.1, 0.18, v * 0.55, 'triangle');
}

/** Hai nốt cao ngắn — gợi “ting ting” khi đúng */
export function playAnswerTingTing(volume = 0.34): void {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === 'suspended') void ctx.resume();
  const t = ctx.currentTime;
  const v = Math.min(0.45, Math.max(0.08, volume));
  beep(ctx, 1046.5, t, 0.07, v, 'sine');
  beep(ctx, 1318.5, t + 0.11, 0.07, v * 0.92, 'sine');
}

/** Hai nốt trầm xuống — gợi “tè tè” khi sai */
export function playAnswerTete(volume = 0.28): void {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === 'suspended') void ctx.resume();
  const t = ctx.currentTime;
  const v = Math.min(0.4, Math.max(0.06, volume));
  beep(ctx, 220, t, 0.09, v, 'triangle');
  beep(ctx, 175, t + 0.13, 0.11, v * 0.82, 'triangle');
}
